<template>
  <div>
    <div id="app" v-bind:class="{contrastMode}">
      <top-bar
        v-bind:contrastMode="contrastMode"
        v-bind:fontSize="fontSize"
        :onContrastChange="handleOnContrastChange"
        :onFontSizeChange="handleOnFontSizeChange"
      ></top-bar>
      <router-view :key="$route.fullPath" v-bind:contrastMode="contrastMode"></router-view>
    </div>
    <footer>
      <cookie-law :theme="contrastMode ? 'dark' : 'light'" :buttonText="$t('COOKIE.BUTTON')">
        <div slot="message">{{ $t("COOKIE.MESSAGE") }}</div>
      </cookie-law>
      <custom-footer v-bind:contrastMode="contrastMode"></custom-footer>
    </footer>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import TopBar from "./components/TopBar.vue";
import CustomFooter from "./components/Footer.vue";

export default {
  name: "app",
  data: () => {
    return {
      contrastMode: false,
      fontSize: "regular",
      htmlElement: null
    };
  },
  created() {
    this.htmlElement = document.getElementById("main-tag");
    // set contrast mode from cookies
    this.contrastMode = this.$contrast.isContrastModeOn();
    // set font size from cookies
    this.handleOnFontSizeChange(this.$fontSize.getFontSize());
  },
  methods: {
    handleOnContrastChange() {
      this.contrastMode = this.$contrast.switchContrast();
    },
    handleOnFontSizeChange(size) {
      this.fontSize = this.$fontSize.changeFont(size);
      switch (this.fontSize) {
        case "regular":
          this.htmlElement.classList.remove("mediumText");
          this.htmlElement.classList.remove("bigText");
          this.htmlElement.classList.add("regularText");
          break;
        case "medium":
          this.htmlElement.classList.remove("bigText");
          this.htmlElement.classList.remove("regularText");
          this.htmlElement.classList.add("mediumText");
          break;
        case "big":
          this.htmlElement.classList.remove("mediumText");
          this.htmlElement.classList.remove("regularText");
          this.htmlElement.classList.add("bigText");
          break;
      }
    }
  },
  components: { CookieLaw, TopBar, CustomFooter }
};
</script>

<style lang="scss" scoped>
@import "./styles/_global";

#app {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  min-height: 100vh;
}

footer {
  position: relative;
  bottom: 0;
}

::v-deep {
  .Cookie--dark {
    background-color: $darkTextColor;
    padding: 30px 20px;
    .Cookie__button {
      background-color: $darkBackgroundColor;
      color: $darkTextColor;
      padding: 10px 16px;
      border-radius: 5px;
    }
  }

  .Cookie--light {
    background-color: $accentColor;
    padding: 30px 20px;
    .Cookie__button {
      background-color: $lightBackgroundColor;
      color: $lightTextColor;
      padding: 10px 16px;
      border-radius: 5px;
    }
  }
}
</style>
